export const INDEX = `{
  news(
    first: 200,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }
  }

  stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "0"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }

  soldStocks: stocks(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "1"
        }
      }
    }
  ) {
    nodes {
      id
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        capacity
        modelYear
        mileage
        sold
      }
    }
  }
}`;
export function SINGLE(id) {
  return `{
    newsItem(
      id: "${id}",
      idType: DATABASE_ID
    ) {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      excerpt(format: RAW)
      content(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }

    news(
      first: 5,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        featuredImage {
          node {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
        }
      }
    }

    stocks(
      first: 4,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        },
        metaQuery: {
          metaArray: {
            key: "sold",
            value: "0"
          }
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        carCategories {
          nodes {
            slug
            name
          }
        }
        makers {
          nodes {
            slug
            name
          }
        }
        acf {
          carImage {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          carPrice
          capacity
          modelYear
          mileage
          sold
        }
      }
    }

    soldStocks: stocks(
      first: 4,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        },
        metaQuery: {
          metaArray: {
            key: "sold",
            value: "1"
          }
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        carCategories {
          nodes {
            slug
            name
          }
        }
        makers {
          nodes {
            slug
            name
          }
        }
        acf {
          carImage {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          carPrice
          capacity
          modelYear
          mileage
          sold
        }
      }
    }
  }`;
}
//# sourceMappingURL=query.js.map
